import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { EmployeeContractManagerLinkEffects } from './employee-contract-manager-link.effects'
import * as fromEmployeeContractManagerLink from './employee-contract-manager-link.reducer'
import { EmployeeContractManagerLinkService } from './employee-contract-manager-link.service'
import { EmployeeContractManagerLinkSerializer } from './employee-contract-manager-link.serializer'

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature(fromEmployeeContractManagerLink.FEATURE_NAME, fromEmployeeContractManagerLink.employeeContractManagerLinkReducer),
        EffectsModule.forFeature([EmployeeContractManagerLinkEffects])
    ],
    declarations: [],
    exports: [],
    providers: [
        EmployeeContractManagerLinkService,
        {
            provide: EmployeeContractManagerLinkSerializer,
            useClass: EmployeeContractManagerLinkSerializer
        }
    ]
})
export class EmployeeContractManagerLinkModule {}
